import Utilities from '@/Utility/Utilities';

export default class LocatorHelper {

    public static buildLocator(...elements: ObservableOrDefault<string | number>[]): KnockoutComputed<string> {
        const length = elements.length;

        let cancelLocator = false;

        const locator = ko.computed(() => {
            let buildedLocator = '';
            for (let i = 0; i < length; i++) {
                const currentLocatorElement = elements[i];
                let currentLocatorElementResolved: string | number;

                if (Utilities.isFunction(currentLocatorElement))
                    currentLocatorElementResolved = (currentLocatorElement as KnockoutObservable<string | number>)();
                else if (Utilities.isNumeric(currentLocatorElement))
                    currentLocatorElementResolved = currentLocatorElement.toString();
                else
                    currentLocatorElementResolved = currentLocatorElement as string;

                if (Utilities.isNullOrUndefined(currentLocatorElementResolved) || Utilities.isBlank(currentLocatorElementResolved.toString())) {
                    cancelLocator = true;
                    break;
                }

                buildedLocator = LocatorHelper.concat(buildedLocator, currentLocatorElementResolved.toString());
            }

            return buildedLocator;
        });

        if (cancelLocator) {
            locator.dispose();
            return null;
        }

        return locator;
    }

    private static concat(string1: string, string2: string): string {
        if (Utilities.isNullOrUndefined(string1) || Utilities.isBlank(string1))
            return string2;

        if (Utilities.isNullOrUndefined(string2) || Utilities.isBlank(string2))
            return string1;

        while(string1.endsWith('.'))
            string1 = string1.slice(0, string1.length - 1);

        while (string2.startsWith('.'))
            string2 = string2.slice(1, string1.length);

        return string1 + '.' + string2;
    }

}